import { render, staticRenderFns } from "./home.vue?vue&type=template&id=fda26ff6&scoped=true"
import script from "./home.ts?vue&type=script&lang=ts&external"
export * from "./home.ts?vue&type=script&lang=ts&external"
import style0 from "./home.vue?vue&type=style&index=0&id=fda26ff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda26ff6",
  null
  
)

export default component.exports